export default "__VITE_ASSET__giheBHz9__ 600w";